import * as React from 'react';
import { dataStructure, AccountType } from '@goldwasserexchange/oblis-frontend-utils';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import ouiBase from '@goldwasserexchange/oui';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { LearnMoreButton } from './learnMore';
import {
  globalPlusTwoLinesIntro, goldTwoLinesIntro, premiumTwoLinesIntro, ServiceSection,
} from '../../../../AccountType';
import { ServiceSectionContainer } from './container';
import { UnorderedListWithBar } from '../../../../../OUI-dom/List';

const containers = (
  <>
    <TopModel<{
      fontSize: ouiStyle.InStyle['fontSize'],
      color: ouiStyle.InStyle['color'],
      textAlign: ouiStyle.InStyle['textAlign'],
      lineFactor: ouiStyle.InStyle['lineFactor'],
    }>
      name="HeadingSectionTitleContainer-2"
      fontSize="xm"
      lineFactor={2}
      color={ouiStyle.Constants.Colors.accent}
      textAlign="center"
    >
      {ouiDom.HeadingSection.DomH2}
    </TopModel>
    <TopModel<{
      fontSize: ouiStyle.InStyle['fontSize'],
      color: ouiStyle.InStyle['color'],
      textAlign: ouiStyle.InStyle['textAlign'],
    }>
      name="HeadingSectionIntroContainer-2"
      fontSize="m"
      color={ouiStyle.Constants.Colors.accent}
      textAlign="center"
    >
      {ouiDom.P.DomPContainer}
    </TopModel>
    <TopModel<{
      textAlign: ouiStyle.InStyle['textAlign'],
    }>
      name="HeadingSectionIllustrationContainer"
      textAlign="center"
    >
      {ouiDom.HeadingSection.DomIllustrationContainer}
    </TopModel>
  </>
);

const AdvantagesList = (props: React.PropsWithChildren<{}>) => {
  const { children } = props;
  const sectionName = ouiBase.HeadingSection.useHeadingSectionName();
  return (
    <UnorderedListWithBar
      list={[`0-${sectionName}`, `1-${sectionName}`, `2-${sectionName}`]}
      color={ouiStyle.Constants.Colors.primary}
      textAlign="center"
      fontSize="xs"
      paddingVertical="simple"
    >
      {children}
    </UnorderedListWithBar>
  );
};

export const ServiceSections = () => (
  <ServiceSectionContainer>
    {dataStructure.accountType.list.map((accountType, index) => (
      <ServiceSection
        key={accountType}
        accountType={accountType}
        index={index}
      >
        <TopModel
          name="AdvantagesList"
        >
          {AdvantagesList}
        </TopModel>
        <TopModel name={`HeadingSectionIntroContent-${AccountType.RTO}-section`}>
          {goldTwoLinesIntro}
        </TopModel>
        <TopModel name={`HeadingSectionIntroContent-${AccountType.CONSEIL}-section`}>
          {premiumTwoLinesIntro}
        </TopModel>
        <TopModel name={`HeadingSectionIntroContent-${AccountType.GESTION}-section`}>
          {globalPlusTwoLinesIntro}
        </TopModel>
        {containers}
        <LearnMoreButton
          accountType={accountType}
          marginVertical="double"
        />
      </ServiceSection>
    ))}
  </ServiceSectionContainer>
);
